/* eslint-disable max-len */
import React from 'react';
import { Link } from 'react-router-dom';
import {
  Breadcrumb, Form, Input, Button, InputNumber,
} from 'antd';

import { useTranslation } from 'react-i18next';
import { SaveOutlined } from '@ant-design/icons';
// import { PlusOutlined } from '@ant-design/icons';

import withAuth from '@common/hocs/withAuth';
import MainLayout from '@common/layouts/MainLayout';
// import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
// import { faSearch } from '@fortawesome/free-solid-svg-icons';

import useCreateFirmwares from './useCreateModelsInverters';
import styles from './CreateInvertersModel.module.less';

function CreateFirmwares({ ...props }) {

  const { t } = useTranslation();
  const {
    onFinishFailed, onFinish,
    formOnValuesChange,
    dataForm,
    idToEdit,
    cancelCreateEditDevice,
  } = useCreateFirmwares();

  return (
    <MainLayout applyWidthLimit>
      <div className={styles.wrapper}>
        <Breadcrumb className={styles.date_wrapper}>
          <Breadcrumb.Item className={styles.breadcrumb}>
            <Link to="/dispositivos/administrar/model-inverters">{t('menu_items.main.modelInverters')}</Link>
          </Breadcrumb.Item>
          {(idToEdit)
            ? (
              <>
                <Breadcrumb.Item className={styles.breadcrumb}>{t('menu_items.main.devices_edit')}</Breadcrumb.Item>
                <Breadcrumb.Item className={styles.breadcrumb}>{idToEdit}</Breadcrumb.Item>
              </>
            )
            : <Breadcrumb.Item className={styles.breadcrumb}>{t('views.create_modelsInverter.new_modelInverter')}</Breadcrumb.Item>}
        </Breadcrumb>
        <Form
          name="CreateModelInverter"
          labelCol={{ span: 10 }}
          wrapperCol={{ span: 22 }}
          layout="vertical"
          initialValues={{
            ...dataForm, ...dataForm.characteristics, remenber: true,
            // remember: true, name: 'jhon', client: 'example', state: 'normal',
          }}
          values={{ segment: 'jhon', version: 'example' }}
          onFinish={onFinish}
          onFinishFailed={onFinishFailed}
          onValuesChange={formOnValuesChange}
          autoComplete="off"
        >
          <div className={styles.containerForm}>
            <div className={styles.cancelBtn}>
              <Button onClick={cancelCreateEditDevice}>X</Button>
            </div>
            <div className={styles.column}>

              <Form.Item
                className={styles.label}
                label={t('views.createModelInverter.form.name')}
                name="name"
                rules={[
                  { required: true, message: t('views.createModelInverter.form.message') },
                  { type: 'string', max: 16, message: t('views.createModelInverter.form.message') },
                ]}
              >
                <Input className={styles.input} placeholder={t('views.createModelInverter.form.inverterCharacteristics')} />
              </Form.Item>

              <Form.Item
                className={styles.label}
                label={t('views.createModelInverter.form.maxuminPower')}
                name="maximumPower"
                rules={[
                  { type: 'number' },
                ]}
              >
                <InputNumber type="number" min="0" step="0.01" className={styles.input_number} placeholder={t('views.createModelInverter.form.inverterCharacteristics')} />
              </Form.Item>

              <Form.Item
                className={styles.label}
                label={t('views.createModelInverter.form.maximunVoltageCC')}
                name="maximunVoltageCC"
                rules={[
                  { type: 'number' },
                ]}
              >
                <InputNumber type="number" min="0" step="0.01" className={styles.input_number} placeholder={t('views.createModelInverter.form.inverterCharacteristics')} />
              </Form.Item>

              <Form.Item
                className={styles.label}
                label={t('views.createModelInverter.form.startVoltage')}
                name="startVoltage"
                rules={[
                  { type: 'number' },
                ]}
              >
                <InputNumber type="number" min="0" step="0.01" className={styles.input_number} placeholder={t('views.createModelInverter.form.inverterCharacteristics')} />
              </Form.Item>

              <Form.Item
                className={styles.label}
                label={t('views.createModelInverter.form.nominalVoltage')}
                name="nominalVoltage"
                rules={[
                  { type: 'number' },
                ]}
              >
                <InputNumber type="number" min="0" step="0.01" className={styles.input_number} placeholder={t('views.createModelInverter.form.inverterCharacteristics')} />
              </Form.Item>

              <Form.Item
                className={styles.label}
                label={t('views.createModelInverter.form.MPTTVoltageRange')}
                name="MPTTVoltageRange"
                rules={[
                  { type: 'string', max: 16, message: t('views.createModelInverter.form.message') },
                ]}
              >
                <Input className={styles.input} placeholder={t('views.createModelInverter.form.inverterCharacteristics')} />
              </Form.Item>

            </div>
            <div className={styles.column}>
              <Form.Item
                className={styles.label}
                label={t('views.createModelInverter.form.maxCurrentInput')}
                name="MaxCurrentInput"
                rules={[
                  { type: 'number' },
                ]}
              >
                <InputNumber type="number" min="0" step="0.01" className={styles.input_number} placeholder={t('views.createModelInverter.form.inverterCharacteristics')} />
              </Form.Item>

              <Form.Item
                className={styles.label}
                label={t('views.createModelInverter.form.maxCurrentShrotcut')}
                name="MaxCurrentShortCut"
                rules={[
                  { type: 'number' },
                ]}
              >
                <InputNumber type="number" min="0" step="0.01" className={styles.input_number} placeholder={t('views.createModelInverter.form.inverterCharacteristics')} />
              </Form.Item>

              <Form.Item
                className={styles.label}
                label={t('views.createModelInverter.form.photovoltaicInputs')}
                name="PhotovoltaicInputs"
                rules={[
                  { type: 'number' },
                ]}
              >
                <InputNumber type="number" min="0" step="0.01" className={styles.input_number} placeholder={t('views.createModelInverter.form.inverterCharacteristics')} />
              </Form.Item>

              <Form.Item
                className={styles.label}
                label={t('views.createModelInverter.form.Efficiency')}
                name="Effinciency"
                rules={[
                  { type: 'number' },
                ]}
              >
                <InputNumber type="number" min="0" step="0.01" className={styles.input_number} placeholder={t('views.createModelInverter.form.inverterCharacteristics')} />
              </Form.Item>

              <Form.Item
                className={styles.label}
                label={t('views.createModelInverter.form.typeInverter')}
                name="typeInverter"
                rules={[
                  { required: true, message: t('views.createModelInverter.form.message') },
                  { type: 'string', max: 16, message: t('views.createModelInverter.form.message') },
                ]}
              >
                <Input className={styles.input} placeholder={t('views.createModelInverter.form.inverterCharacteristics')} />
              </Form.Item>
            </div>
          </div>
          <Form.Item wrapperCol={{ offset: 0 }} className={styles.containerBtn}>
            <Button className={styles.btn} type="primary" htmlType="submit" icon={<SaveOutlined />}>
              {t('views.create_devices.form.button')}
            </Button>
          </Form.Item>
        </Form>
      </div>
    </MainLayout>
  );

}

export default withAuth(CreateFirmwares);
